export function hideNavOnScroll(navId, threshold = 10) {
    let lastScrollY = window.scrollY;
    let ticking = false;
    let isHidden = false;

    function handleScroll() {
        const navbar = document.getElementById(navId);
        if (!navbar) return;

        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY + threshold && !isHidden) {
            navbar.classList.add("hidden-nav");
            isHidden = true;
        } else if (currentScrollY < lastScrollY - threshold && isHidden) {
            navbar.classList.remove("hidden-nav");
            isHidden = false;
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener("scroll", () => {
        if (!ticking) {
            requestAnimationFrame(handleScroll);
            ticking = true;
        }
    });

    const observer = new IntersectionObserver(
        ([entry]) => {
            const navbar = document.getElementById(navId);
            if (navbar && entry.isIntersecting) {
                navbar.classList.remove("hidden-nav");
                isHidden = false;
            }
        },
        { threshold: 0.1 }
    );

    observer.observe(document.body);
}
